import React, { useState } from 'react'
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { redirectTo } from 'src/utils/Http';
import { optionStyles, locale } from '../customize';

export default function NextStep({ payrollRulesGroup, setTutorialStep2, setTutorialStep3 }) {
    const [run, setRun] = useState(true)
    const { t } = useTranslation()

    const checkLocationPath = (target) => {
        if (payrollRulesGroup)
            return window.location.pathname == `/clients/payroll_rules_groups/${payrollRulesGroup.id}/allowances` ? target : '.NotFoundClass'
        return '.none'
    }
    const step = [
        {
            target: checkLocationPath(".Sidebar__naviItemWrap--2h0Fb:nth-child(1) a[href='/dashboards'] svg"),
            content: t('features.GuideTour.PayrollRulesGroups.NextStep'),
            placement: 'auto',
            disableBeacon: true,

        },
        {
            target: checkLocationPath(".Sidebar__naviItemWrap--2h0Fb:nth-child(1) a[href='/dashboards'] svg"),
            content: t('features.GuideTour.PayrollRulesGroups.NextStep'),
            placement: 'auto',
        },
    ];

    const handleCallback = data => {
        const { action, index, lifecycle, type } = data;

        if (action === 'skip') {
                setTutorialStep2(undefined)
        }
        if (type === 'step:after' && index === 0) {
            if (action === 'next') {
                setRun(false)
                setTutorialStep2(undefined)
                setTutorialStep3({ run: true, stepIndex: 0, tourCompleted: false, type: 'setInfo' })
                redirectTo('/dashboards')
            }
        }
    };

    return (
        <Joyride
            steps={step}
            run={run}
            stepIndex={0}
            callback={handleCallback}
            styles={optionStyles}
            locale={locale(t)}
            continuous
            showSkipButton
            scrollToFirstStep
            hideCloseButton
            disableOverlayClose />
    )
}

